var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-layout"},[_c('drag-container',_vm._b({staticStyle:{"min-height":"600px"},attrs:{"show":_vm.show},on:{"input":_vm.changeElement}},'drag-container',_vm.value,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }